module.exports = __webpack_public_path__ + "static/media/mail.c82c7768.svg";